class viewUser {
    constructor($state) {

        this.key = 'view-user';
        this.level = 'row';
        this.state = $state;
    }

    action(payload, store) {
        return this.state.go('app.users.list');
    }

}

angular
    .module('festzelt-os.modules.users')
    .factory('viewUser', [
        '$state',
        $state => new viewUser($state)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/users/workflows/list/view-user.js